import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import "./Users.css";

const Header = ({
  globalFilterValue,
  onGlobalFilterChange,
  clearFilter,
  openAddUserDialog,
}) => {
  return (
    <div className="flex justify-content-between header-container">
      <div className="flex search-container">
        <IconField iconPosition="right" className="search-field">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
            style={{ fontFamily: "poppins" }}
            className="search-input"
          />
        </IconField>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Clear"
          outlined
          onClick={clearFilter}
          className="clear-button"
          style={{
            backgroundColor: "#D97A07",
            border: "none",
            color: "#fff",
            marginLeft: "10px",
            marginRight: "10px",
            fontFamily: "poppins",
          }}
        />
      </div>
      <Button
        type="button"
        icon="pi pi-user-plus"
        label="Add User"
        className="add-button"
        style={{
          backgroundColor: "#0D2E4D",
          border: "none",
          color: "#fff",
          fontFamily: "poppins",
          whiteSpace: "nowrap", // This prevents text wrapping
          minWidth: "140px", // Give it enough width
        }}
        onClick={openAddUserDialog}
      />
    </div>
  );
};

export default Header;
